import { useEffect, useState } from 'react'

import clsx from 'clsx'
import { useParams } from 'react-router'

import StaffAllList from './all/StaffAllList'
import StaffComplaintList from './compliant/StaffComplaintList'
import StaffNonComplaintList from './nonCompliant/StaffNonComplaintList'
import StaffScratchedList from './scratched/StaffScratchedList'

import useStaffListingRoot from '../hooks/useStaffListingRoot'

import { MANAGE_CLINIC_EXHIBITOR_CONSTS } from '../data/exhibitor.data.const'

// Constants
const MCEC = MANAGE_CLINIC_EXHIBITOR_CONSTS

const StaffListing = () => {
  const { eventId } = useParams<{ eventId?: string }>()
  const { loading, getEventStaffDoc, onStaffProfileClick, ...categorizedStaffs } =
    useStaffListingRoot(eventId as any)

  const [activeTab, setActiveTab] = useState<string>(MCEC.TABS[0].id)

  useEffect(() => {
    if (!eventId) return
    getEventStaffDoc(eventId).then()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId])

  /**
   * @info Handles data table tabs,
   */
  const handleActiveTab = (item: { tab: string; id: string; disabled?: boolean }) => {
    setActiveTab(item.id)
  }

  const getActiveDataTable = () => {
    switch (activeTab) {
      case MCEC.TABS[0].id:
        return (
          <StaffAllList
            searchValue={''}
            loading={loading}
            onStaffProfileClick={onStaffProfileClick}
            staffs={categorizedStaffs.staffs}
          />
        )

      case MCEC.TABS[3].id:
        return (
          <StaffScratchedList
            searchValue={''}
            loading={loading}
            onStaffProfileClick={onStaffProfileClick}
            staffs={categorizedStaffs.scratchedStaffs}
          />
        )

      case MCEC.TABS[1].id:
        return (
          <StaffComplaintList
            searchValue={''}
            loading={loading}
            onStaffProfileClick={onStaffProfileClick}
            staffs={categorizedStaffs.complaintStaffs}
          />
        )

      case MCEC.TABS[2].id:
        return (
          <StaffNonComplaintList
            loading={loading}
            searchValue={''}
            onStaffProfileClick={onStaffProfileClick}
            staffs={categorizedStaffs.nonComplaintStaffs}
          />
        )
    }
  }

  return (
    <div className="p-5 rounded-xl bg-SeabiscuitWhiteThemeColor w-full flex flex-col">
      <div className={clsx('flex items-center justify-between mb-6')}>
        <div className="flex items-center mb-0 mt-2">
          {MCEC.TABS?.map((currentItem, index) => {
            return (
              <div
                key={`${JSON.stringify(currentItem)}a${index}`}
                onClick={() => handleActiveTab(currentItem)}
                className={`py-3 px-3 min-w-[110px] h-[50px] text-[15px] text-center pt-3.5 relative cursor-pointer mr-2 rounded-xl ease-in duration-200 ${activeTab === currentItem.id ? 'bg-SeabiscuitMainThemeColor/5 text-SeabiscuitMainThemeColor' : 'text-SeabiscuitDark200ThemeColor'}`}
              >
                {currentItem.tab}
              </div>
            )
          })}
        </div>
      </div>
      <div className="w-full">{getActiveDataTable()}</div>
    </div>
  )
}

export default StaffListing
